import { z } from 'zod';
import { uuidSchema } from './common.js';
/**
 * Savings initiatives (BP-03/D-026/D-033) — the IL0-IL5 pipeline record. References the supplier +
 * category masters by ID (D-100). Lean first cut: one primary bucket + value per initiative, its IL
 * stage, baseline, target year and owner. The multi-value-line structure, the calculation-method
 * policy + smart gates, and the gate approval workflow come in later slices. Shapes shared by the API
 * (validation) and the web app (types).
 */
export const savingsBucketSchema = z.enum(['pl_savings', 'cost_avoidance', 'budget_capital', 'working_capital', 'esg_value']);
export const ilStageSchema = z.enum(['IL0', 'IL1', 'IL2', 'IL3', 'IL4', 'IL5']);
const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Expected a date as YYYY-MM-DD');
export const savingsInitiativeSchema = z.object({
    id: uuidSchema,
    supplierId: uuidSchema.nullable(),
    categoryId: uuidSchema.nullable(),
    title: z.string(),
    bucket: savingsBucketSchema,
    ilStage: ilStageSchema,
    value: z.number().nullable(),
    baseline: z.number().nullable(),
    currency: z.string(),
    targetYear: z.number().nullable(),
    ownerUserId: uuidSchema.nullable(),
    effectiveDate: z.string().nullable(),
    isDemo: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
/** POST /savings/initiatives — log an initiative (source 'manual'). */
export const createSavingsInitiativeSchema = z
    .object({
    title: z.string().trim().min(1).max(240),
    supplierId: uuidSchema.optional(),
    categoryId: uuidSchema.optional(),
    bucket: savingsBucketSchema.optional(),
    ilStage: ilStageSchema.optional(),
    value: z.number().finite().optional(),
    baseline: z.number().finite().optional(),
    currency: z.string().trim().length(3).optional(),
    targetYear: z.number().int().min(2000).max(2100).optional(),
    ownerUserId: uuidSchema.optional(),
    effectiveDate: isoDate.optional(),
})
    .strict();
/** PATCH /savings/initiatives/:id — edit any field (incl. advancing the IL stage). */
export const patchSavingsInitiativeSchema = z
    .object({
    title: z.string().trim().min(1).max(240).optional(),
    supplierId: uuidSchema.nullable().optional(),
    categoryId: uuidSchema.nullable().optional(),
    bucket: savingsBucketSchema.optional(),
    ilStage: ilStageSchema.optional(),
    value: z.number().finite().nullable().optional(),
    baseline: z.number().finite().nullable().optional(),
    currency: z.string().trim().length(3).optional(),
    targetYear: z.number().int().min(2000).max(2100).nullable().optional(),
    ownerUserId: uuidSchema.nullable().optional(),
    effectiveDate: isoDate.nullable().optional(),
})
    .strict();
//# sourceMappingURL=savings.js.map